import { GiphyFetch } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { uniqueId } from 'lodash'
import { useContext, useRef } from 'react'
import { MAX_PREVIEW_WIDTH } from '../../../constants'
import { UgeEditorContext } from '../../../contexts/editor'
import { UgeLayersContext } from '../../../contexts/layers'
import { Grid } from './style'

type Props = {
    className?: string
    searchTerm: string
}

const StickersEditorGrid = ({ className, searchTerm }: Props) => {
    const { apiKey, fetchFavorites } = useContext(UgeEditorContext)
    const { addLayer } = useContext(UgeLayersContext)
    const giphyFetchRef = useRef<GiphyFetch>(new GiphyFetch(apiKey))

    const fetchGifs = async (offset: number) => {
        if (fetchFavorites && searchTerm === 'giphyfavorites') {
            return fetchFavorites(offset)
        }

        if (searchTerm === 'giphytrending') {
            return giphyFetchRef.current.trending({ offset, type: 'stickers' })
        }

        return giphyFetchRef.current.search(searchTerm, { offset, type: 'stickers' })
    }

    const onGifClick = (gif: IGif) => {
        const aspectRatio = gif.images.original.width / gif.images.original.height
        const source = aspectRatio > 1 ? gif.images.fixed_height.url : gif.images.fixed_width.url

        addLayer({
            id: uniqueId('uge-sticker-'),
            name: gif.title,
            props: { source },
            type: 'image',
            user: gif.user,
        })
    }

    return (
        <Grid
            className={className}
            columns={5}
            fetchGifs={fetchGifs}
            gutter={30}
            hideAttribution
            key={searchTerm}
            noLink
            noResultsMessage="No stickers found"
            width={MAX_PREVIEW_WIDTH - 60}
            onGifClick={onGifClick}
        />
    )
}

export default StickersEditorGrid
